import { getField, updateField } from 'vuex-map-fields'

export default {
  namespaced: true,
  state: () => ({

  }),
  getters: {
    getField
  },
  mutations: {
    updateField
  },
  actions: {

  }
}
